import React, { Component } from "react";
import { TextControl } from '@wordpress/components';


class Productid extends Component {

    constructor(props) {
        super(props);
    }



    render() {

        const { attributes: {productId}, setAttributes } = this.props;

        const changeFunction = (value) => {
            setAttributes({
                productId: value
            });
        }

        return (
            <div className="components-base-control">
                <div className="components-base-control__field">
                    <label className="components-base-control__label">Product ID</label>
                    <TextControl
                        value={ productId }
                        onChange={ changeFunction }
                    />
                </div>
            </div>
        );

    }
}


export default Productid;